<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-indent:0em !important;">In memory of my parents, mentors and deceased family members and friends.</p><br/>
<p style="text-indent:0em !important;">In appreciation of any colour-blind person.</p><br/>
<p style="text-indent:0em !important;">To the residents of Israel and Palestine.</p><br/>
<p style="text-indent:0em !important;">To the residents of Australia.</p><br/>
<p style="text-indent:0em !important;">To my children, grandchildren, friends and students.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?7c5f7851